import { api } from './api';
import { ILoginResolve, IPasswordLoginParams, IUserInfoResolve } from './user.types';

/**
 * 登录
 */
export const PasswordLogin = async (params: IPasswordLoginParams): Promise<ILoginResolve> => {
  return await api.post('/AuthenticateInfo/Authenticate', params);
};

export const GetLogInModel = async (): Promise<IUserInfoResolve> => {
  return await api.get('/AuthenticateInfo/GetLogInModel');
};
